import { defineMessages, type MessageValue } from 'react-intl';

export const lineItemPriceMessages = defineMessages<{
  readonly pricePerEach: { readonly price: MessageValue };
}>({
  pricePerEach: {
    defaultMessage: '{price}/ea',
    description: 'Lite item | Price | Price per each',
  },
});
